import { render, staticRenderFns } from "./mailTemplates.vue?vue&type=template&id=488be5e6"
import script from "./mailTemplates.vue?vue&type=script&lang=js"
export * from "./mailTemplates.vue?vue&type=script&lang=js"
import style0 from "./mailTemplates.vue?vue&type=style&index=0&id=488be5e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports